<template>
	<rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
		stroke-linejoin="round" fill="none" />
	<path d="M2 10h20" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
</template>
